import { render, staticRenderFns } from "./AIAssistant.vue?vue&type=template&id=a439b19a&scoped=true"
import script from "./AIAssistant.vue?vue&type=script&lang=js"
export * from "./AIAssistant.vue?vue&type=script&lang=js"
import style0 from "./AIAssistant.vue?vue&type=style&index=0&id=a439b19a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a439b19a",
  null
  
)

export default component.exports